import * as EventManager from "../events/event-manager.js";

/**
 * Calendar
 */
export const Calendar = (function () {

  let calendar;
  let appType;
  let calendarEvents;
  let eventManager;
  let inviteeListURL;
  let inviteeListRequestData;

  /**
   * Initialises Calendar module by:
   * Sets the type of app "SP" vs "Citizen" - use to define where to get the Event data from
   * Sets the eventManager based on appType and passes "this" in order to tell the eventManager how to handle 
   * UI events in this specific context (see eventHandlers object set and returned further below)
   * @param {*} appConfig 
   */
  let init =  function (appConfig) {

      appType = appConfig.app_type;
      inviteeListURL = appConfig.invitee_list_url;
      inviteeListRequestData = appConfig.invitee_list_request_data;
      eventManager = EventManager.EventManager(appType, Calendar);
      load()
      eventManager.addEventListeners();

  }

  /**
   * Sets the FullCalendar.io (see their docs) config
   * Instantiates the Calendar object
   * Renders the Calendar
   */
  let load = function() {

    //get events from the events manager and set current date
    calendarEvents = eventManager.events;
    let initialDate = new Date();

    let desktopConfig = {
      plugins: [ dayGridPlugin, bootstrapPlugin, interactionPlugin ],
      headerToolbar: {
        center: 'title',
        left: 'prev,next,today',
        right: 'dayGridMonth,dayGridDay,dayGridWeek',
      },
      buttonText: {
        prev: '<',
        next: '>',
        today: 'Today',
        day: 'Day',
        week: 'Week',
        month: 'Month'
      },
      themeSystem: 'bootstrap',
      initialView: 'dayGridMonth',
      initialDate: initialDate,
      height: 'auto',
      dayMaxEvents: 2,
      events: calendarEvents,
      eventTimeFormat: { 
        hour: 'numeric',
        minute: '2-digit',
        meridiem: false
      },
      displayEventTime : true,
      dateClick: function(date) {
        // Displays the add event modal when clicking on a date in the calendar
        if (appType == "Citizen") {
          eventManager.showAddEventModal(date); //currently only able to add an event via calendar in the Citizen app
        }
    
      },
      eventClick: function(eventDetails){
        // Displays the edit event modal when clicking on calendar Event
        //TODO check type of event and show modal accordingly (e.g. appointment model - to be created)
        eventManager.showViewEventModal(eventDetails);
      },
    }
    let mobileConfig = {
      
        plugins: [ dayGridPlugin, bootstrapPlugin, interactionPlugin ],
        headerToolbar: {
          left: 'title',
          right: 'dayGridMonth,dayGridDay,dayGridWeek',
        },
        footerToolbar: {
          right: 'today',
          left: 'prev,next'
        },
        buttonText: {
          prev: '<',
          next: '>',
          today: 'Today',
          day: 'Day',
          week: 'Week',
          month: 'Month'
        },
        fixedWeekCount: false,
        themeSystem: 'bootstrap',
        initialView: 'dayGridMonth',
        initialDate: initialDate,
        dayMaxEvents: 2,
        height: (window.screen.height / 100) * 72,
        events: calendarEvents,
        eventTimeFormat: { 
          hour: 'numeric',
          minute: '2-digit',
          meridiem: false
        },
        displayEventTime : true,
        dateClick: function(date) {
          // Displays the add event modal when clicking on a date in the calendar
          if (appType == "Citizen") {
            eventManager.showAddEventModal(date); //currently only able to add an event via calendar in the Citizen app
          }
        },
        eventClick: function(eventDetails){
          // Displays the edit event modal when clicking on calendar Event
          eventManager.showViewEventModal(eventDetails);
        },
    }

    // Instatiate the Full Callendar - if the element exists
    let calendarElement = document.getElementById(`myds-calendar`);
    if ( calendarElement ) {
      // Change the config depending on device
      let config = window.matchMedia("(max-width: 767px)").matches ? mobileConfig : desktopConfig;
      calendar = new FullCalendar(calendarElement, config);
      calendar.render(); 
    }

  }


  ////////Functions required for use of Events module//////////

  /**
   * Defines how events are to be handled in this context for use in Events module
   * These functions must be set (even if they are are empty) in order to use Events
   */
  let eventHandlers = {
    saveEvent : function(form) {
      calendar.addEvent(form);
      calendar.render();
    },
    deleteEvent : function(eventID) {
      let event = calendar.getEventById(eventID);
      event.remove();
    },
    editEvent : function(eventID, form) {
      let event = calendar.getEventById(eventID);
      event.remove();
      calendar.addEvent(form);
      calendar.render();
    },
    updateEventInviteResponse : function(eventID, inviteStatus) {
      let event = calendar.getEventById(eventID);
      event.setExtendedProp('status', inviteStatus)
      calendar.render();
    }
  }

  /**
   * 
   * This function is a requirement of the events module, however - at time of writing no content is required
   * in the context of a Calendar
   * @returns empty string since this function has not been implemented.
   */
  let getContextID = function() {
    return "";
  }

  /**
   * gets invitee list required for events module to display list of invitees that can be added to an event
   * @returns ajax promise
   */
  let getInviteeList = function() {
    return $.ajax({
      url: inviteeListURL,
      type: 'get',
      data: inviteeListRequestData
    });
  }

  return {
    init : init,
    load : load,
    eventHandlers : eventHandlers,
    getContextID : getContextID,
    getInviteeList : getInviteeList
  }

}());